import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ECommerceProductTemplatesEffects } from '@api-ui-app/src/app/e-commerce-product-templates/+state/e-commerce-product-templates.effects';
import { ProductCatalogueTemplatesListPageTabLinksComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-catalogue-templates-list-page-tab-links/product-catalogue-templates-list-page-tab-links.component';
import { ProductTemplateNameModalComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-template-name-modal/product-template-name-modal.component';
import { ProductTemplateNameSearchFieldComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-template-name-search-field/product-template-name-search-field.component';
import { ProductTemplatesListEmptyStateComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list-empty-state/product-templates-list-empty-state.component';
import { ProductTemplatesListItemFilterColorComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list-item-filter-color/product-templates-list-item-filter-color.component';
import { ProductTemplatesListItemFilterRegularComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list-item-filter-regular/product-templates-list-item-filter-regular.component';
import { ProductTemplatesListItemFilterComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list-item-filter/product-templates-list-item-filter.component';
import { ProductTemplatesListItemComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list-item/product-templates-list-item.component';
import { ProductTemplatesListSearchParamsComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list-search-params/product-templates-list-search-params.component';
import { ProductTemplatesListSortingOrderSelectorComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list-sorting-order-selector/product-templates-list-sorting-order-selector.component';
import { ProductTemplatesListComponent } from '@api-ui-app/src/app/e-commerce-product-templates/components/product-templates-list/product-templates-list.component';
import { ProductCatalogueTemplatesListPageComponent } from '@api-ui-app/src/app/e-commerce-product-templates/containers/product-catalogue-templates-list-page/product-catalogue-templates-list-page.component';
import { ProductTemplatesStoreSelectionModalComponent } from '@api-ui-app/src/app/e-commerce-product-templates/containers/product-templates-store-selection-modal/product-templates-store-selection-modal.component';
import { ProductTemplatesVariantSelectionModalComponent } from '@api-ui-app/src/app/e-commerce-product-templates/containers/product-templates-variant-selection-modal/product-templates-variant-selection-modal.component';
import { ECommerceProductTemplatesFacade } from '@api-ui-app/src/app/e-commerce-product-templates/e-commerce-product-templates.facade';
import { ECommerceProductTemplatesGraphQlService } from '@api-ui-app/src/app/e-commerce-product-templates/services/e-commerce-product-templates-graph-ql.service';
import { ECommerceProductWizardInitializationRouteService } from '@api-ui-app/src/app/e-commerce-stores/services/e-commerce-product-wizard/e-commerce-product-wizard-initialization-route.service';
import { ProductAddModule } from '@api-ui-app/src/app/product/product-add/product-add.module';
import { SharedModule } from '@api-ui-app/src/app/shared/shared.module';
import { ECommerceProductGraphQlService } from '@gelato-api-ui/core/e-commerce/services/e-commerce-product-graph-ql.service';
import { ECommerceProductTemplateNameModalService } from '@gelato-api-ui/sdk/src/lib/shared/services/e-commerce-product-template-name-modal.service';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromProductTemplates from './+state/e-commerce-product-templates.reducer';

const components = [
  ProductTemplateNameModalComponent,
  ProductTemplatesListComponent,
  ProductTemplatesListEmptyStateComponent,
  ProductTemplatesListItemComponent,
  ProductTemplatesListItemFilterComponent,
  ProductTemplatesListItemFilterRegularComponent,
  ProductTemplatesListItemFilterColorComponent,
  ProductTemplatesListSearchParamsComponent,
  ProductTemplatesListSortingOrderSelectorComponent,
  ProductTemplatesStoreSelectionModalComponent,
  ProductTemplatesVariantSelectionModalComponent,
  ProductCatalogueTemplatesListPageComponent,
  ProductCatalogueTemplatesListPageTabLinksComponent,
  ProductTemplateNameSearchFieldComponent,
];

const modules = [SharedModule, FormsModule, ProductAddModule];

@NgModule({
  declarations: [...components],
  imports: [
    ...modules,
    StoreModule.forFeature(
      fromProductTemplates.eCommerceProductTemplatesFeatureKey,
      fromProductTemplates.eCommerceProductTemplatesReducerToken,
    ),
    EffectsModule.forFeature([ECommerceProductTemplatesEffects]),
  ],
  exports: [...modules, ...components],
  providers: [
    {
      provide: fromProductTemplates.eCommerceProductTemplatesReducerToken,
      useValue: fromProductTemplates.reducer,
    },
    ECommerceProductTemplatesFacade,
    ECommerceProductTemplatesGraphQlService,
    ECommerceProductWizardInitializationRouteService,
    ECommerceProductTemplateNameModalService,
    ECommerceProductGraphQlService,
  ],
})
export class ECommerceProductTemplatesSharedModule {}
